import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-campo-default-admin',
  templateUrl: './campo-default-admin.component.html',
  styleUrls: ['./campo-default-admin.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CampoDefaultAdminComponent),
      multi: true
    }]
})
export class CampoDefaultAdminComponent implements ControlValueAccessor {

  @Input("descripcion_etiqueta") descripcion_etiqueta: string = "Campo genérico";
  @Input("placeholder_input") placeholder_input: string = "Ingrese su texto aquí";
  @Input("mensaje_error") mensaje_error: string = "";
  @Input("model_value") model_value: string = '';
  @Input("type") type: string = 'string';
  @Output("model_valueChange") model_valueChange: EventEmitter<string> = new EventEmitter<string>();
  @Output("enterPressed") enterPressed: EventEmitter<string> = new EventEmitter<string>();
  @Output("blurEmitter") blurEmitter: EventEmitter<string> = new EventEmitter<string>();
  modelValue: string = '';
  private onChange = (value: string) => { };
  private onTouched = () => { };

  writeValue(value: string): void {
    this.modelValue = value || '';
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
  }

  onInputChange(value: string): void {
    this.modelValue = value;
    // Notifica al ControlValueAccessor sobre el cambio de valor
    this.model_valueChange.emit(this.modelValue);
    this.onChange(this.modelValue);
  }

  // onInputChange(event) {
  //   this.model_value = event.target.value;
  //   this.model_valueChange.emit(this.model_value);
  // }


  onEnterPressed() {
    this.enterPressed.emit(this.model_value);
  }

  onBlur() {
    console.log("blur");
    this.blurEmitter.emit(this.model_value);
  }

}
